<div class="d-lg-none d-block">
    <fgb-page-header [pageTitle]="'nav.gallery'" [showBalance]="false" />
  </div>
  
  <fgb-worksheet-list [isGalleryPage]="true"></fgb-worksheet-list>
  